import { render, staticRenderFns } from "./ContactCategoryList.vue?vue&type=template&id=76f823e5&scoped=true&"
import script from "./ContactCategoryList.vue?vue&type=script&lang=js&"
export * from "./ContactCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./ContactCategoryList.vue?vue&type=style&index=0&id=76f823e5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f823e5",
  null
  
)

export default component.exports